import React from "react";
import { ListGroup, InputGroup, FormControl, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";

const EventSidebar = ({ events, searchTerm, setSearchTerm, onSelectEvent, selectedEvent, onNewEvent }) => {
  return (
    <div className="p-3">
      <InputGroup className="mb-3">
        <FormControl
          placeholder="Search events"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </InputGroup>
<ListGroup style={{ maxHeight: "70vh", overflowY: "auto" }}>
  {events.map((ev) => (
    <ListGroup.Item
      key={ev.event_id}
      active={selectedEvent?.event_id === ev.event_id}
      onClick={() => onSelectEvent(ev)}
      action
      variant="light"
      style={{
        backgroundColor:
          selectedEvent?.event_id === ev.event_id ? "#e2dabf" : undefined,
        borderColor:
          selectedEvent?.event_id === ev.event_id ? "#dee2e6" : undefined,
      }}
    >
      <div className="fw-bold">{ev.name}</div>
      <div className="text-muted">{ev.date}</div>

      {ev.storage && (
        <div className="small text-secondary mt-1">
          {ev.storage.total_images} photo{ev.storage.total_images !== 1 ? "s" : ""} – {" "}
          {(ev.storage.used_memory / 1024 / 1024).toFixed(1)} MB
        </div>
      )}
    </ListGroup.Item>
  ))}
</ListGroup>
<Button
  className="mt-3 w-100 d-flex align-items-center justify-content-center gap-2 fw-semibold text-dark"
  variant="outline-warning"
  size="sm"
  onClick={onNewEvent}
>
  <FontAwesomeIcon icon={faPlus}/>
  New Event
</Button>
    </div>
  );
};

export default EventSidebar;